

import React, { memo, useCallback, useContext } from 'react';
import cx from 'classnames';

import {
  getDataTableRowHoverableType,
  getDataTableRowIdAttr,
  getDataTableRowIndicator,
  isDataTableOddRow,
  isDataTableTreeRowNodeRoot,
  isDataTableRowHoverable } from
'../../utils/dataTableRow';
import DataTableRow from '../DataTableRow';
import { DataTableContext } from '../../context/dataTableContext';
import '../../styles/_data-table-body-row.scss';











const DataTableBodyRow = (props) => {
  const {
    rowIndex,
    treeRowNode,
    isLastVisibleInBranch,
    isSpacer,
    isExpander,
    isExpanded,
    children
  } = props;

  const {
    styleType,
    getRowIndicator,
    getOnRowClick
  } = useContext(DataTableContext);

  const { data, id } = treeRowNode;
  const isRoot = isDataTableTreeRowNodeRoot(treeRowNode);
  const isOdd = isDataTableOddRow(rowIndex);
  const indicator = getDataTableRowIndicator(data, rowIndex, getRowIndicator, isSpacer);
  const onRowClick = getOnRowClick && getOnRowClick(data, rowIndex);
  const hoverableType = getDataTableRowHoverableType(onRowClick);
  const rowId = getDataTableRowIdAttr(id, isSpacer);

  const onClick = onRowClick && useCallback(() => {
    onRowClick(data, rowIndex);
  }, [data, onRowClick]);

  return (
    <DataTableRow
      className={cx('data-table-body-row', {
        'data-table-body-row--spacer': isSpacer,
        'data-table-body-row--expander': isExpander,
        'data-table-body-row--root': isRoot,
        'data-table-body-row--child': !isRoot,
        'data-table-body-row--expanded': isExpanded,
        'data-table-body-row--collapsed': !isExpanded,
        'data-table-body-row--odd': isOdd,
        'data-table-body-row--even': !isOdd,
        'data-table-body-row--last-visible-in-branch': isLastVisibleInBranch,
        [`data-table-body-row--hoverable-${hoverableType}`]: isDataTableRowHoverable(getOnRowClick),
        [`data-table-body-row--${styleType}`]: styleType,
        [`data-table-body-row--${indicator}`]: indicator
      })}
      rowIdAttr={rowId}
      onClick={onClick}>

      {children}
    </DataTableRow>);

};

export default memo(DataTableBodyRow);